"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_react_1 = require("mobx-react");
const React = require("react");
const Store_1 = require("../Store");
let SearchResultsInfo = class SearchResultsInfo extends React.Component {
    render() {
        const resultText = Store_1.default.results && Store_1.default.results.total > 0 ? Store_1.default.translations.resultsFound : Store_1.default.translations.noResultsFound;
        return React.createElement("p", null, resultText.replace("$0", Store_1.default.previousQuery).replace("$1", Store_1.default.results.total.toString()));
    }
};
SearchResultsInfo = __decorate([
    mobx_react_1.observer
], SearchResultsInfo);
exports.default = SearchResultsInfo;
